import React from "react";
import Choose from "../../../assets/image/choose-1.jpg"
import Bgchose from "../../../assets/image/pattern-3.png"
import legal from "../../../assets/image/ation1.svg"
import Begal from "../../../assets/image/patt1.svg"
const WhyChooseVisarzo = () => {
    return (
        <section
            className="relative py-16 bg-[#eff2f5]  md:py-24 bg-cover bg-center bg-no-repeat"
            style={{
                backgroundImage: `url(${Bgchose})`,
            }}>
            <div className="max-w-7xl mx-auto px-4">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

                    {/* LEFT CONTENT */}
                    <div>
                        <p className="uppercase tracking-widest font-[600] text-[#777777]">
                            WHY CHOOSE TRINITY


                        </p>

                        <h2 className="text-3xl md:text-5xl font-bold text-black my-6">
                            Effortless Processing & Higher Success Rates

                        </h2>

                        <div className="flex gap-2 items-center mb-4">
                            <div className="w-12 h-1 bg-[#ec4e4f] rounded"></div>
                            <div className="w-1 h-1 bg-[#ec4e4f] rounded"></div>
                            <div className="w-1 h-1 bg-[#ec4e4f] rounded"></div>
                            <div className="w-1 h-1 bg-[#ec4e4f] rounded"></div></div>

                        <p className="text-[15px] text-[#555555] mb-10 leading-relaxed">
                            We simplify complex immigration rules and help you navigate every step with confidence.


                        </p>

                        {/* Feature 1 */}
                        <div className="flex items-start gap-5 mb-8">
                            <div className="w-[72px] h-[60px] mt-3 flex-shrink-0 flex items-center justify-center  bg-white shadow">
                                <img
                                    src={legal}
                                    alt="Legal Immigration"
                                    className="w-full h-full object-contain p-2 "
                                />
                            </div>
                            <div>
                                <h4 className="text-[26px] text-[#222222] font-[600] mb-1">
                                    High Immigration Success Rates
                                </h4>
                                <p className="text-[15px] text-[#555555] leading-relaxed">
                                    Our partnered legal teams maintain strong visa approval records year after year.
                                </p>
                            </div>
                        </div>

                        {/* Feature 2 */}
                        <div className="flex items-start gap-5">

                            <div className="w-[72px] mt-3 h-[60px] flex-shrink-0 flex items-center justify-center  bg-white shadow">
                                <img
                                    src={Begal}
                                    alt="Legal Immigration"
                                    className="w-full h-full object-contain p-2"
                                />
                            </div>
                            <div>
                                <h4 className="text-[26px] text-[#222222] font-[600] mb-1">
                                    Document Support
                                </h4>
                                <p className="text-[15px] text-[#555555] leading-relaxed">
                                    We help you understand, collect, and organize all required documents for your application.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT IMAGE */}
                    <div className="relative">
                        <img
                            src={Choose}
                            alt="Why Choose Trinity"
                            className="w-full h-full object-cover rounded-lg"
                        />
                    </div>

                </div>
            </div>
        </section>
    );
};

export default WhyChooseVisarzo;
